import { Typography } from "@mui/material";
import { format, parseISO } from "date-fns";
import { useState } from "react";
import { useRevalidator } from "react-router-dom";

import Modal from "../../../../../../components/global/Modal";
import ResponseModal from "../../../../../../components/global/ResponseModal";
import useService from "../../../../../../hooks/useService";

export default function DeletePayment({
  activeItem,
  checkTypeOptions,
  open,
  setActiveItem,
  setOpen,
}) {
  const settlementCheckRepository = useService("repositories/settlement-check-repository");
  const { revalidate } = useRevalidator();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setActiveItem(null);
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      await settlementCheckRepository.delete(activeItem.id);
      setLoading(false);
      setOpenSuccess(true);
      revalidate();
      handleClose();
    } catch (error) {
      setLoading(false);
      if (error.response) {
        setOpenError(!openError);
        const res = error.response.data;
        const errArr = [];
        for (const item in res) {
          errArr.push(item + `: ${res[item]}`);
        }
        setErrorArray(errArr);
      }
    }
  };

  return (
    <>
      <Modal
        open={open}
        fullWidth
        maxWidth="sm"
        title="Delete Payment"
        onClose={handleClose}
        actions={[
          {
            isLoading: loading,
            onClick: handleDelete,
            label: "Delete Payment",
            variant: "outlined",
            className: "border-red-500 text-red-500 hover:bg-red-500 hover:text-white",
          },
        ]}
      >
        <div className="flex w-full flex-wrap items-center p-6">
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Type:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {checkTypeOptions.find((opt) => opt.value === activeItem?.checkType)?.display_name ??
                "" ??
                ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              From:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {activeItem?.paidBy?.name ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              To:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {activeItem?.paidTo?.name ?? ""}
            </Typography>
          </div>
          {activeItem?.intendedRecipient?.name && (
            <div className="flex w-full">
              <Typography variant="h6" className="w-fit text-lg font-bold">
                Intended Recipient:
              </Typography>
              <Typography variant="h6" className="ml-2 w-fit text-lg">
                {activeItem?.intendedRecipient?.name ?? ""}
              </Typography>
            </div>
          )}
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Amount:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              ${activeItem?.amount ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="w-fit text-lg font-bold">
              Date:
            </Typography>
            <Typography variant="h6" className="ml-2 w-fit text-lg">
              {activeItem?.checkDate ? format(parseISO(activeItem?.checkDate), "MM/dd/yyyy") : ""}
            </Typography>
          </div>
        </div>
      </Modal>
      <ResponseModal
        title="Payment Removed"
        description="Payment has been successfully deleted"
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
        handleCloseFunc={() => setOpenSuccess(false)}
      />
      <ResponseModal
        title="Error Removing Payment"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  );
}
